import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "project-sidebar" }
const _hoisted_2 = { class: "project-sidebar-inner bg-white p-4" }
const _hoisted_3 = { class: "sidebar-row mb-5" }
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "sidebar-title mb-4" }, "Project Info", -1)
const _hoisted_5 = { class: "list-unstyled ps-2" }
const _hoisted_6 = {
  key: 0,
  class: "mb-4"
}
const _hoisted_7 = /*#__PURE__*/_createVNode("strong", null, "Company:", -1)
const _hoisted_8 = { class: "mb-4" }
const _hoisted_9 = /*#__PURE__*/_createVNode("strong", null, "Site Link: ", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "mb-4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("strong", null, "Type:", -1)
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createVNode("strong", null, "Source Code: ", -1)
const _hoisted_15 = { class: "sidebar-row" }
const _hoisted_16 = /*#__PURE__*/_createVNode("h3", { class: "sidebar-title mb-3" }, "Technologies Used", -1)
const _hoisted_17 = { class: "webdev-icons row mb-5 justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")

  return (_openBlock(), _createBlock("aside", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("ul", _hoisted_5, [
          (_ctx.project.companyName)
            ? (_openBlock(), _createBlock("li", _hoisted_6, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "building",
                  class: "me-3 text-primary",
                  transform: "grow-6 down-2"
                }),
                _hoisted_7,
                _createTextVNode(" " + _toDisplayString(_ctx.project.companyName), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode("li", _hoisted_8, [
            _createVNode(_component_font_awesome_icon, {
              icon: "external-link-alt",
              class: "me-3 text-primary",
              transform: "grow-6 down-2"
            }),
            _hoisted_9,
            _createVNode("a", {
              href: _ctx.project.archivedUrl || _ctx.project.url
            }, _toDisplayString(_ctx.project.url), 9, ["href"]),
            (_ctx.project.archivedUrl)
              ? (_openBlock(), _createBlock("span", _hoisted_10, " (archived)"))
              : _createCommentVNode("", true)
          ]),
          _createVNode("li", _hoisted_11, [
            _createVNode(_component_font_awesome_icon, {
              icon: "wrench",
              class: "me-3 text-primary",
              transform: "grow-6 down-2"
            }),
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.project.type), 1)
          ]),
          (_ctx.project.repositoryUrl)
            ? (_openBlock(), _createBlock("li", _hoisted_13, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fab', 'github'],
                  class: "me-3 text-primary",
                  transform: "grow-6 down-2"
                }),
                _hoisted_14,
                _createVNode("a", {
                  href: _ctx.project.repositoryUrl
                }, _toDisplayString(_ctx.project.repositoryUrl), 9, ["href"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode("div", _hoisted_15, [
        _hoisted_16,
        _createVNode("div", _hoisted_17, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.project.technologies, (iconName) => {
            return (_openBlock(), _createBlock("div", {
              key: iconName,
              class: "webdev-icon col-2 col-sm-1 col-lg-2 me-0 mb-4"
            }, [
              _createVNode("img", {
                class: "img-fluid",
                src: `/images/webdev-icons/${iconName}.svg`,
                title: iconName
              }, null, 8, ["src", "title"])
            ]))
          }), 128))
        ])
      ])
    ])
  ]))
}